const baseSlides = [
  { src: "/images/img1.jpg" },
  { src: "/images/img3.jpg" },
  { src: "/images/img4.jpg" },
  { src: "/images/img5.jpg" },
  { src: "/images/img8.jpeg" },
  { src: "/images/DSC_6810.jpg" },
  { src: "/images/DSC_6815.jpg" },
  { src: "/images/DSC_6821.jpg" },
  { src: "/images/DSC_6823.jpg" },
  { src: "/images/DSC_6844 (1).jpg" },
  { src: "/images/img14.jpg" },
  { src: "/images/img15.jpg" },
  { src: "/images/img16.jpg" },
  { src: "/images/img18.jpg" },
  { src: "/images/img19.jpg" },
  { src: "/images/img20.jpg" },
  { src: "/images/img22.jpg" },
  { src: "/images/img23.jpg" },
  { src: "/images/img25.jpg" },
  { src: "/images/img26.jpg" },
  { src: "/images/img27.jpg" },
  { src: "/images/img28.jpg" },
  { src: "/images/img29.jpg" },
  { src: "/images/img30.jpg" },
  { src: "/images/img34.jpg" },
  { src: "/images/img35.jpg" },
  { src: "/images/img36.jpg" },
  { src: "/images/img37.jpg" },
  { src: "/images/img38.jpg" },
  { src: "/images/img39.jpg" },
  { src: "/images/img42.jpg" },
  { src: "/images/img43.jpg" },
  { src: "/images/img46.jpg" },
  { src: "/images/img49.jpg" },
  { src: "/images/garden1.jpeg" },
  { src: "/images/garden2.jpeg" },
  { src: "/images/garden3.jpeg" },
];

export default baseSlides;
